<div class="page-padding" style="padding: 24px;">
  <div style="margin-left: 39%;" *ngIf="equipmentDetails == null" [@enterAnimation]>
    <mat-spinner></mat-spinner>
  </div>


  <div #btnStatusChange class="alert cursor-pointer" (click)="openChangeStatusModal()" *ngIf="showImplement"
    (mouseenter)="mouseOverStatus()" (mouseleave)="mouseLeaveStatus()">
    <i class="material-icons alert__icon">build</i>
    <div class="alert__content">
      <span class="alert__content__title">{{implementStatusText}}</span>
      <span class="alert__content__message" [innerHTML]="implementStatusDesc"></span>
    </div>
  </div>


  <div class="panel" *ngIf="equipmentDetails != null &&  !showImplementStatusModal">
    <mat-expansion-panel class="parametersPanel">
      <mat-expansion-panel-header>
        <div class="panel__header">
          <span class="panel__header__title" style="    margin-left: -24px;">
            Equipment Details
          </span>
        </div>
      </mat-expansion-panel-header>
      <div class="panel__content flex flex--align-center">
        <div class="overall-eval-container">
          <img [src]="getImage(equipmentDetails.EquipmentPhoto)" class="equipment-photo" />
          <div class="bold font-size--xl margin-r--24 {{getEvalClass(equipmentDetails.PercentWorn)}}"
            style="border-radius: 4px;color: white;     padding-top: 12%;">
            {{equipmentDetails.PercentWorn | number:'1.0-1'}}%
          </div>
        </div>
        <div class="column-container flex-grow">
          <div class="column-container__column">
            <div class="text-block">
              <span class="text-block__label">
                Customer
              </span>
              <span class="text-block__important">
                {{equipmentDetails.CustomerName}}
              </span>
            </div>
            <div class="text-block">
              <span class="text-block__label">
                Job Site
              </span>
              <span class="text-block__important">
                {{equipmentDetails.JobsiteName}}
              </span>
            </div>
          </div>
          <div class="column-container__column">
            <div class="text-block">
              <span class="text-block__label">
                Serial Number
              </span>
              <span class="text-block__important">
                <a routerLink="/get-equipment/{{equipmentDetails.equipmentId}}">
                  {{equipmentDetails.SerialNumber}} </a>
              </span>
            </div>
            <div class="text-block">
              <span class="text-block__label">
                Unit Number
              </span>
              <span class="text-block__important">
                <a routerLink="/get-equipment/{{equipmentDetails.equipmentId}}">
                  {{equipmentDetails.UnitNumber}}</a>
              </span>
            </div>
          </div>
          <div class="column-container__column">
            <div class="text-block">
              <span class="text-block__label">
                Last Inspection Date
              </span>
              <span class="text-block__important">
                {{equipmentDetails.LastInspectionDate}}
              </span>
            </div>
            <div class="text-block">
              <span class="text-block__label">
                Next Inspection Date
              </span>
              <span class="text-block__important">
                {{ equipmentDetails.NextInspectionDate }}
              </span>
            </div>
          </div>
          <div class="column-container__column">
            <div class="text-block">
              <span class="text-block__label">
                Meter Reading (SMU)
              </span>
              <span class="text-block__important">
                {{equipmentDetails.Smu}}
              </span>
            </div>
            <div class="text-block">
              <span class="text-block__label">
                Life to Date (LTD)
              </span>
              <span class="text-block__important">
                {{equipmentDetails.Ltd}}
              </span>
            </div>
          </div>
          <div class="column-container__column">
            <div class="text-block">
              <span class="text-block__label">
                Make
              </span>
              <span class="text-block__important">
                {{equipmentDetails.Make}}
              </span>
            </div>
            <div class="text-block">
              <span class="text-block__label">
                Model
              </span>
              <span class="text-block__important">
                {{equipmentDetails.Model}}
              </span>
            </div>
          </div>
          <div class="column-container__column">
            <div class="text-block">
              <span class="text-block__label">
                Family
              </span>
              <span class="text-block__important">
                {{equipmentDetails.Family}}
              </span>
            </div>
            <div class="text-block">
              <span class="text-block__label">
                Setup Date
              </span>
              <span class="text-block__important">
                {{equipmentDetails.EquipmentSetupDate}}
              </span>
            </div>
          </div>
        </div>
      </div>
    </mat-expansion-panel>
  </div>

  <div class="panel" *ngIf="equipmentDetails != null &&  showImplementStatusModal">
    <div class="panel__header">
      <span class="panel__header__title">
        Inventory Details
      </span>
      <button *ngIf="implement.status =='Undergoing Rebuild'" mat-raised-button color="warn"
        (click)="CompleteRebuild()">Complete Rebuild</button>
    </div>
    <div class="panel__content flex flex--align-center">

      <div class="column-container flex-grow" style="justify-content: space-evenly;">
        <div class="column-container__column">
          <div class="text-block">
            <span class="text-block__label">
              Customer
            </span>
            <span class="text-block__important">
              {{equipmentDetails.CustomerName}}
            </span>
          </div>

        </div>
        <div class="column-container__column">
          <div class="text-block">
            <span class="text-block__label">
              Job Site
            </span>
            <span class="text-block__important">
              {{equipmentDetails.JobsiteName}}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="flex columns" *ngIf="equipmentDetails != null">
    <div class="panel panel--tasks" style="flex-shrink: 0.1;width:55%;height: 210px;">
      <div class="panel__header">
        <span class="panel__header__title">
          Tasks
        </span>
      </div>
      <div class="panel__content flex flex--align-stretch" style="height: 150px;">

        <a *ngIf="!showImplementStatusModal && !isJobRoleDefault && EnablePreference.showChangeJobsite" class="square-button" (click)="openChangeJobsite()">
          <i class="material-icons square-button__icon">language</i>
          <span class="square-button__label">Change Jobsite</span>
        </a>

        <a *ngIf="showImplementStatusModal  && !isJobRoleDefault && EnablePreference.showChangeJobsite" class="square-button"
          (click)="openChangeJobsiteInventory()">
          <i class="material-icons square-button__icon">language</i>
          <span class="square-button__label">Change Jobsite</span>
        </a>

        <a *ngIf="!showImplementStatusModal && isJobRoleDefault && EnablePreference.showChangeJobsite" class="square-button" style="color: lightgrey;">
          <i class="material-icons square-button__icon">language</i>
          <span class="square-button__label">Change Jobsite</span>
        </a>

        <a *ngIf="showImplementStatusModal  && isJobRoleDefault && EnablePreference.showChangeJobsite" class="square-button" style="color: lightgrey;">
          <i class="material-icons square-button__icon">language</i>
          <span class="square-button__label">Change Jobsite</span>
        </a>


        <a *ngIf="!showImplementStatusModal  && !isJobRoleDefault && EnablePreference.showUpdateUsage" class="square-button" (click)="openUpdateMeter()">
          <i class="material-icons square-button__icon">access_time</i>
          <span class="square-button__label">Update Usage</span>
        </a>
        <a *ngIf="showImplementStatusModal  && isJobRoleDefault && EnablePreference.showUpdateUsage" class="square-button" style="color: lightgray">
          <i class="material-icons square-button__icon">access_time</i>
          <span class="square-button__label">Update Usage</span>
        </a>



      </div>
    </div>


    <!-- <div class="panel panel--next-inspection" style="flex-shrink:0.1; margin-left: 0; height: 210px;">
        <div class="panel__header">
          <span class="panel__header__title">
            Next Inspection
          </span>
        </div>
        <div class="panel__content flex flex--align-stretch">
          <div class="square-button" (click)="openInspectionPlannerDialog()">
            <i class="material-icons square-button__icon">event_note</i>
            <span class="smuReadings">Smu : {{equipmentDetails.NextSmu}}</span>
            <span class="square-button__label">{{ equipmentDetails.NextInspectionDate| date:'dd/MMM/yyyy' }}</span>
          </div>
        </div>
      </div> -->

    <div class="panel panel--inspections" style="margin-left:15px;width: 512px; height: 210px;">
        <div class="panel__header">
          <span class="panel__header__title">
            Inspection History
          </span>
        </div>
        <div class="panel__content flex flex--align-stretch" style="overflow-x: auto;     justify-content: start;">
  
          <div class="square-button" *ngFor="let inspection of inspectionDetailsforDFI;" [matMenuTriggerFor]="inspectionMenu">
         
              <div class=" CelltextWrap {{getStatusCode(inspection.status)}}" style="width: 90px;text-align: center;">
                <span class="square-button__label CelltextWrap  " style="color: white; padding: 1px;"
                  title="{{inspection.FormName}} / SMU - {{inspection.SMU}}">{{inspection.FormName}}</span>
                  <span class="square-button__label CelltextWrap  " style="color: white; padding: 1px;"
                 ></span>
              </div>
           
            <span class="smuReadings">Smu : {{inspection.SMU}}</span>          
            <span class="square-button__label" style="margin-top: 10px;">{{inspection.ActionDate_}}</span>
              <mat-menu #inspectionMenu="matMenu">
                  <button *ngIf="!isJobRoleDefault" mat-menu-item (click)="openLink(inspection.formUploadedId,inspection.uploadID )">{{'View / Edit'}}</button>
                  <!-- <button mat-menu-item (click)="openLink('pdf', inspection.InspectionDate, inspection)">{{'PDF Report'}}</button> -->
              </mat-menu>
          </div>
        </div>
      </div>
  </div>
  <mat-tab-group>

    <div *ngIf="equipmentDetails != null">
      <div style="margin-left: 39%;" *ngIf="loading">
        <mat-spinner> </mat-spinner>
      </div>
      <mat-tab label="ASSETS DETAILS">
        <div *ngIf="ImplementForEquipmentDetails != null">

          <div style="margin-left: 39%;" *ngIf="loading_imp">
            <mat-spinner> </mat-spinner>
        </div>

          <!-- <ng-container *ngFor="let implement of ImplementForEquipmentDetails">
            <div style="overflow-x: auto; " class="mat-elevation-z8">

              <div style="background-color: white; padding: 1%;     margin-right: -15%;    max-width: 100%;">
                
                <div class="panel__header">
                  <span class="panel__header__title" style="font-size: 20px;">
                    System Summary
                  </span>
                </div>
                <div class="panel__sub-header panel__content no-padding" style="margin-top: 2px;    max-width: 95%;">

                  <div class="column-container flex-grow">
                    <div class="column-container__column">


                    </div>

                    <div class="column-container__column">
                      <div class="text-block">
                        <span class="text-block__label">
                          System Type
                        </span>
                        <span style="font-size: 18px; font-weight: 500;"
                          class="text-block__important ">
                          {{implement.ImplementTypeName}}
                        </span>
                      </div>
                    </div>
                    <div class="column-container__column">
                      <div class="text-block">
                        <span class="text-block__label">
                          System
                        </span>
                        <span style="font-size: 18px; font-weight: 500;"
                          class="text-block__important ">
                          {{implement.Implement}}
                        </span>
                      </div>
                    </div>
                    <div class="column-container__column">
                      <div class="text-block">
                        <span class="text-block__label">
                          % Worn
                        </span>
                        <span class="text-block__important {{getEvalClass(implement.WorstWorn)}}">
                          {{implement.WorstWorn}}%
                        </span>
                      </div>
                    </div>


                    <div class="column-container__column">
                      <div class="text-block">
                        <span class="text-block__label">
                          Life
                        </span>
                        <span class="text-block__important">
                          {{ implement.Life}}
                        </span>
                      </div>
                    </div>
                    <div class="column-container__column">
                      <div class="text-block">
                        <span class="text-block__label">
                          Residual
                        </span>
                        <span class="text-block__important">
                          {{implement.Residual}}
                        </span>
                      </div>
                    </div>




                  </div>
                </div>
              </div>

              <app-dfi-observation-details [Componenthistroy]="implement.ComponentQuestions">
              </app-dfi-observation-details>

            </div>
          </ng-container> -->
          <ng-container *ngFor="let implement of ImplementForEquipmentDetails">
            <div style="overflow-x: auto;" class="mat-elevation-z8">
              <div style="background-color: white; padding: 1%;     margin-right: -15%;">
                <app-implement-details-header [Implemetdetails]="implement.ImplementSummary" [evaldetails]="ImplementForEquipmentDetails"></app-implement-details-header>
              </div>
              <ng-container *ngFor="let item2 of implement.SchematicAndObservationPoints">
                <!-- <app-observation-details [SchematicAndObservationPoints]="item2" [(cusID)]="CustomerId">
                </app-observation-details> -->

                <app-dfi-observation-details [SchematicAndObservationPoints]="item2" [(cusID)]="CustomerId" [(ImplementId)]="implement.ImplementSummary.Id" [(SMU)]="SMU"  [isCrack]="1" (updateObs)="loadImplementDetails()">
                </app-dfi-observation-details>

              </ng-container>
            </div>
          </ng-container>
        </div>
      </mat-tab>
      

      <!-- TT-5484 -->
      <!-- <mat-tab label="ASSET DETAIL HISTORY" *ngIf="inspectionDetails!=null"> -->
        <mat-tab label="ASSET INSPECTION HISTORY">
        <div *ngIf="ImplementForEquipmentDetails != null" >
          
          <ng-container *ngFor="let implement of ImplementForEquipmentDetails">
            <div style="overflow-x: auto; " class="mat-elevation-z8">
            
              <div style="background-color: white; padding: 1%;     margin-right: -15%;    max-width: 100%;">
                <app-implement-details-header [Implemetdetails]="implement.ImplementSummary" [evaldetails]="ImplementForEquipmentDetails"></app-implement-details-header>
              </div>
              <ng-container *ngFor="let item2 of implement.SchematicAndObservationPoints">
                <!-- <app-observation-details [SchematicAndObservationPoints]="item2" [(cusID)]="CustomerId">
                </app-observation-details> -->

                <app-asset-detail-history-dfi [SchematicAndObservationPoints]="item2" [(ImplementId)]="implement.ImplementSummary.Id" [(cusID)]="CustomerId" [(SMU)]="SMU" [(equipmentId)]="equipmentId"  [isCrack]="1"  (updateObs)="loadImplementDetails()">
                </app-asset-detail-history-dfi>

              </ng-container>
              
          
            </div>
          </ng-container>
      
          </div>
      </mat-tab>


<!-- TT- 5434 -->
      <mat-tab label="CRACK REGISTER"> 
        <div *ngIf="ImplementForEquipmentDetails != null" >
         
        <ng-container *ngFor="let implement of ImplementForEquipmentDetails">
          <div style="overflow-x: auto; " class="mat-elevation-z8">
          
            <div style="background-color: white; padding: 1%;     margin-right: -15%;    max-width: 100%;">
              <app-implement-details-header [Implemetdetails]="implement.ImplementSummary" [evaldetails]="ImplementForEquipmentDetails"></app-implement-details-header>
            </div>
            <ng-container *ngFor="let item2 of implement.SchematicAndObservationPoints">
              <app-dfi-observation-details [SchematicAndObservationPoints]="item2" [(cusID)]="CustomerId" [(ImplementId)]="implement.ImplementSummary.Id" [(SMU)]="SMU" [isCrack]="2" (updateObs)="loadImplementDetails()">
              </app-dfi-observation-details>
            </ng-container>
        
          </div>
        </ng-container>
    
        </div>
       </mat-tab>




    </div>
  </mat-tab-group>
</div>